import type { Api } from 'datatables.net';
import type { DataTables } from 'datatables.net-fixedcolumns';

// Helps to identify it in our code
export type Datatables<T> = Api<T> & DataTables.Api;

/** Datatables internal type, but we apparently using it anyway.
 * Interface reconstructed from what we 'usually' get from datatables.
 * @see _fnAjaxParameters in jquery.dataTables.mjs */
export interface DataTablesRequestParams {
  draw: number;
  columns: {
    'data': 'function';
    'name': '';
    'searchable': true;
    'orderable': false;
    'search': {
      'value': '';
      'regex': false;
    };
  }[];
  order: {
    'column': number;
    'dir': 'asc' | 'desc';
  }[];
  start: number;
  length: number;
  search: {
    value: string;
    regex: boolean;
  };
}

export const DATATABLES_FIXED_CELL_SELECTOR = '.dtfc-fixed-left';
